import { computed, makeObservable } from 'mobx';
import {Control} from '../../../../../../lib/helpers';
import {MQBehavior, MQLeftSideType, MQOptions, MQRightSideType} from '../../models';

export class MQOptionsStore {
  leftSide: Control<MQLeftSideType>;
  rightSide: MQRightSideType = 'text';
  behavior: Control<MQBehavior>;

  constructor() {
    makeObservable(this);
    this.leftSide = new Control<MQLeftSideType>(
      'left',
      'text'
    );
    this.rightSide = 'text';
    this.behavior = new Control<MQBehavior>(
      'match-behavior',
      'dropdown'
    );
  }

  @computed
  get options(): MQOptions {
    return {
      leftSide: this.leftSide.value,
      rightSide: this.rightSide,
      behavior: this.behavior.value
    };
  }
}
